/* eslint-disable import/prefer-default-export */
import API from './api';

export const getListaArquivosProcessados = (cpfcnpj, filtros = {}) =>
  API.get(`${process.env.REACT_APP_API_HUB}/atualizacao-titulo/v1/${cpfcnpj}`, { params: filtros });

export const getListaRegistrosArquivosProcessados = (uuid, params = {}) =>
  API.get(`${process.env.REACT_APP_API_HUB}/atualizacao-titulo/v1/titulos-importados/${uuid}`, {
    params: {
      cpfcnpj: String(params.cpfcnpj || '').replace(/\D+/g, '')
    }
  });

export const baixarArquivoImportado = (s3path, nomearquivo) =>
  API.post(
    `${process.env.REACT_APP_API_HUB}/atualizacao-titulo/v1/baixar-arquivo-importado`,
    {
      s3path,
      nomearquivo
    },
    {
      responseType: 'blob'
    }
  );

export const processarAtualizacaoArquivos = dados =>
  API.post(`${process.env.REACT_APP_API_HUB}/atualizacao-titulo/v1/processar-titulos`, {
    dados
  });

export const uploadArquivoCnab = formData =>
  API.post(`${process.env.REACT_APP_API_HUB}/atualizacao-titulo/v1`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
